export default __webpack_public_path__ + "static/media/colorSensor.545d3f92.svg";